/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_A3Inputs */

const en_sorter_faq_a3 = /** @type {(inputs: Sorter_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Only the order of object keys is changed. All values, arrays, and nested structures remain identical.`)
};

const ko_sorter_faq_a3 = /** @type {(inputs: Sorter_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 객체 키의 순서만 변경됩니다. 모든 값, 배열, 중첩 구조는 그대로 유지됩니다.`)
};

const ja_sorter_faq_a3 = /** @type {(inputs: Sorter_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。オブジェクトキーの順序のみが変更されます。すべての値、配列、ネストされた構造は同一のまま維持されます。`)
};

/**
* | output |
* | --- |
* | "No. Only the order of object keys is changed. All values, arrays, and nested structures remain identical." |
*
* @param {Sorter_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_a3 = /** @type {((inputs?: Sorter_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_a3(inputs)
	if (locale === "ko") return ko_sorter_faq_a3(inputs)
	return ja_sorter_faq_a3(inputs)
});